import axios ,{AxiosRequestConfig} from "axios";
import CryptoJS from "crypto-js";
import { ConfigApi } from "./ConfigApi";
import Swal from "sweetalert2";
import { isApiUnavailableError } from "./maintenanceInterceptor";
import { isSessionExpiredError } from "./sessionExpiredInterceptor";

type NotificationArgs = Parameters<ConfigApi["notification"]["error"]>[0];

export type Tuple<type1, type2> = {
  item1: type1;
  item2: type2;
};

class MobileWebApiClient {
  private BASE_URL: string;
  private BASE_URLRIC: string;
  private ARCH_BASE_URL:string;
  private HUB_BASE_URL:string;
  private publicKey: string;
  protected _configApi: ConfigApi;
  private xApiKey: string;

  constructor(configApi: ConfigApi) {
    this.BASE_URL = process.env.REACT_APP_API_ENDPOINT as string;
    this.ARCH_BASE_URL=process.env.REACT_APP_ARCH_API_ENDPOINT as string;
    this.HUB_BASE_URL=process.env.REACT_APP_HUB_API_ENDPOINT as string;
    this.publicKey = process.env.REACT_APP_PUBLIC_KEY as string;
    this._configApi = configApi;

    this.BASE_URLRIC = process.env.REACT_APP_API_URL as string;
    this.xApiKey = process.env.REACT_APP_XAPI_KEY as string;
      

  }

  private randomString = (): string => Math.random().toString(36).slice(-8);

  private formatString = (
    inputString: string,
    desiredLength: number,
    paddingChar: string
  ): string => {
    let formattedString = inputString;
    while (formattedString.length < desiredLength) {
      formattedString += paddingChar;
    }
    return formattedString;
  };

  private getHeaders = (contentType = "application/json") => {
    let randomString = this.randomString();
    let apikey = this.publicKey === undefined ? "" : this.publicKey;
    let KEY = this.formatString(
        apikey.replace(/[-:;,._\\@/*&^%$#!()=+]/g, ""),
        32,
        "0"
    );
    let IV = this.formatString(
        `PT${randomString}JAq113vgkeGWPkCEStbILNJCCUfaAgxk5${randomString}q1EfBshryYLoedKxjDqxWKFRf6E${randomString}ZUC5y0CNLWHaIDJU6ozwUVLao${randomString}`.replace(
            /[-:;,._\\@/*&^%$#!()=+]/g,
            ""
        ),
        16,
        "0"
    );
    let key = CryptoJS.enc.Utf8.parse(KEY);
    let iv = CryptoJS.enc.Utf8.parse(IV);
    let encrypted;
    let srcs = CryptoJS.enc.Utf8.parse(this.publicKey);

    encrypted = CryptoJS.AES.encrypt(srcs, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });

    return {
        "public-key": encrypted.ciphertext.toString(),
        www: IV,
        Authorization: `bearer ${this._configApi.authToken}`,
        "X-Api-Key": this.publicKey,
        "Content-Type": contentType, // Set Content-Type based on parameter
    };
};
private getHeadersArch = (contentType = "application/json") => {
  let randomString = this.randomString();
  let apikey =  'cShl4VheZNnOrnwDXmzT0T2F9WcMdin7HK4u6y0NRWbqxjKzeoNiXiXiHtIxtUamCiWKeUtlKjLTwVolFeViStbkQ5K5tQwWUOB0VLrMV0OoJqGajhfsytAMyMtlHZh5';
  let KEY = this.formatString(
      apikey.replace(/[-:;,._\\@/*&^%$#!()=+]/g, ""),
      32,
      "0"
  );
  let IV = this.formatString(
      `PT${randomString}JAq113vgkeGWPkCEStbILNJCCUfaAgxk5${randomString}q1EfBshryYLoedKxjDqxWKFRf6E${randomString}ZUC5y0CNLWHaIDJU6ozwUVLao${randomString}`.replace(
          /[-:;,._\\@/*&^%$#!()=+]/g,
          ""
      ),
      16,
      "0"
  );
  let key = CryptoJS.enc.Utf8.parse(KEY);
  let iv = CryptoJS.enc.Utf8.parse(IV);
  let encrypted;
  let srcs = CryptoJS.enc.Utf8.parse(this.publicKey);

  encrypted = CryptoJS.AES.encrypt(srcs, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
  });

  return {
      "X-Api-Key-AllAccessWeb": 'cShl4VheZNnOrnwDXmzT0T2F9WcMdin7HK4u6y0NRWbqxjKzeoNiXiXiHtIxtUamCiWKeUtlKjLTwVolFeViStbkQ5K5tQwWUOB0VLrMV0OoJqGajhfsytAMyMtlHZh5',
      "Content-Type": contentType, // Set Content-Type based on parameter
  };
};

  // Silent when the failure is the one that raised the maintenance screen: a toast
  // naming a URL on top of that screen is noise, and one per call would stack up.
  private notifyRequestError = (error: unknown, args: NotificationArgs) => {
    if (isApiUnavailableError(error) || isSessionExpiredError(error)) return;
    this._configApi.notification.error(args);
  };

 protected get = async (url: string, responseType: 'json' | 'blob' = 'json'): Promise<any> => {
    return await axios({
      method: "get",
      baseURL:this.BASE_URL,
      url: url,
      responseType,
      headers: this.getHeaders(),
    });
  };

  protected post = async (
    url: string,
    data?: Record<any, any> | string
  ): Promise<any> => {
    const config = {
      method: "post",
      url: url,
      baseURL: this.BASE_URL,
      headers: this.getHeaders(),
      ...(data !== undefined && { data: data }),
    };
    return await axios(config);
  };

  protected tryGet = async (url: string, noContentIsOk: boolean = false, responseType: 'json' | 'blob' = 'json'): Promise<any> => {
    try {
      const res = await axios({
        method: "get",
        baseURL: this.BASE_URL,
        url: url,
        responseType,
        headers: this.getHeaders(),
      });
      if ((res.status === 200 || res.statusText === 'OK') || (noContentIsOk && (res.status === 204 || res.statusText === 'No Content'))) {
        return res;
      }
      this._configApi.notification.error({
        message: 'Network Error',
        description: <><b>URL: </b>{url}<br /><b>STATUS TEXT: </b>{res.statusText}<br /><b>STATUS: </b>{res.status}</>,
        duration: 10,
      });
      console.log(`url:`, url);
      console.log(`response:`, res);
      return undefined;
    } catch (error) {
      this.notifyRequestError(error, {
        message: 'Network Error',
        description: <><b>URL: </b>{url}<br /></>,
        duration: 10,
      });
      console.log(`url:`, url);
      return undefined;
    }
  };

  protected tryGetWithStatus = async (
    url: string
  ): Promise<{ ok: boolean; status: number; data: any }> => {
    try {
      const res = await axios({
        method: "get",
        baseURL: this.BASE_URL,
        url: url,
        headers: this.getHeaders(),
        validateStatus: () => true,
        timeout: 20000,
      });
      return {
        ok: res.status >= 200 && res.status < 300,
        status: res.status,
        data: res.data,
      };
    } catch (error) {
      console.log(`url:`, url);
      return { ok: false, status: 0, data: undefined };
    }
  };

  protected tryGetLocalhost = async (url: string, noContentIsOk: boolean = false): Promise<any> => {

    try {
      const res = await axios({
        method: "get",
        baseURL: this.BASE_URL,
        url: url,
        headers: this.getHeaders(),
      });
      
      if (res.status == 200) {
        return res.data;
      }
      this._configApi.notification.error({
        message: 'API Error',
        description: <><b>URL: </b>{url}<br /><b>STATUS TEXT: </b>{res.statusText}<br /><b>STATUS: </b>{res.status}</>,
        duration: 10,
      });     
      return undefined;
    } catch (error) {
      this.notifyRequestError(error, {
        message: 'Network Error',
        description: <><b>URL: </b>{url}<br /></>,
        duration: 10,
      });
      console.log(`url:`, url);
      return undefined;
    }
  };
  protected tryGetArch = async (url: string): Promise<any> => {

    try {
      const res = await axios({
        method: "get",
        baseURL: this.ARCH_BASE_URL,
        url: url,
        headers:  this.getHeadersArch(),
      });
      if (res.status == 200) {
        return res.data;
      }
      this._configApi.notification.error({
        message: 'API Error',
        description: <><b>URL: </b>{url}<br /><b>STATUS TEXT: </b>{res.statusText}<br /><b>STATUS: </b>{res.status}</>,
        duration: 10,
      });     
      return undefined;
    } catch (error) {
      this.notifyRequestError(error, {
        message: 'Network Error',
        description: <><b>URL: </b>{url}<br /></>,
        duration: 10,
      });
      console.log(`url:`, url);
      return undefined;
    }
  };  
  protected tryDeleteArch = async (url: string): Promise<any> => {

    try {
      const res = await axios({
        method: "delete",
        baseURL: this.ARCH_BASE_URL,
        url: url,
        headers:  this.getHeadersArch(),
      });
      if (res.status == 200) {
        return res.data;
      }
      this._configApi.notification.error({
        message: 'API Error',
        description: <><b>URL: </b>{url}<br /><b>STATUS TEXT: </b>{res.statusText}<br /><b>STATUS: </b>{res.status}</>,
        duration: 10,
      });     
      return undefined;
    } catch (error) {
      this.notifyRequestError(error, {
        message: 'Network Error',
        description: <><b>URL: </b>{url}<br /></>,
        duration: 10,
      });
      console.log(`url:`, url);
      return undefined;
    }
  };  
  protected tryPost = async (
    url: string,
    data?: Record<any, any> | string,
    noContentIsOk: boolean = false
  ): Promise<any> => {
    const config = {
      method: "post",
      url: url,
      baseURL: this.BASE_URL,
      headers: this.getHeaders(),
      ...(data !== undefined && { data: data }),
    };
    try {
      const res = await axios(config);
       if ((res.status === 200 || res.statusText === 'OK') || (noContentIsOk && (res.status === 204 || res.statusText === 'No Content'))) {
        return res;
      }
       this._configApi.notification.error({
         message: 'Network Error',
         description: <><b>URL: </b>{url}<br /><b>STATUS TEXT: </b>{res.statusText}<br /><b>STATUS: </b>{res.status}</>,
         duration: 10,
       });
      console.log(`url:`, url);
      console.log(`request data:`, data);
      console.log(`response:`, res);
      return undefined;
    } catch (error) {
      this.notifyRequestError(error, {
        message: 'Network Error',
        description: <><b>URL: </b>{url}<br /></>,
        duration: 10,
      });
      console.log(`url:`, url);
      console.log(`request data:`, data);
      return undefined;
    }
  };
  protected tryPostArch = async (
    url: string,
    data?: Record<any, any> | string,
    noContentIsOk: boolean = false
  ): Promise<any> => {
    const config = {
      method: "post",
      url: url ,
      baseURL:this.ARCH_BASE_URL,
        headers:this.getHeadersArch(),
      ...(data !== undefined && { data: data }),
    };
    try {
      const res = await axios(config);
      console.log('test response arch',res)
      if (res.status === 200) {
        return res;
      }
      this._configApi.notification.error({
        message: 'Network Error',
        description: <><b>URL: </b>{url}<br /><b>STATUS TEXT: </b>{res.statusText}<br /><b>STATUS: </b>{res.status}</>,
        duration: 10,
      });
      console.log(`url:`, url);
      console.log(`request data:`, data);
      console.log(`response:`, res);
      return undefined;
    } catch (error) {
      this.notifyRequestError(error, {
        message: 'Network Error',
        description: <><b>URL: </b>{url}<br /></>,
        duration: 10,
      });
      console.log(`url:`, url);
      console.log(`request data:`, data);
      return undefined;
    }
  };
  protected tryPutArch = async (
    url: string,
    data?: Record<any, any> | string,
    noContentIsOk: boolean = false
  ): Promise<any> => {
    const config = {
      method: "put",
      url: url ,
      baseURL: this.ARCH_BASE_URL,
      headers:  this.getHeadersArch(),
      ...(data !== undefined && { data: data }),
    };
    try {
      const res = await axios(config);
      console.log('test response arch',res)
      if (res.status === 200) {
        return res;
      }
      this._configApi.notification.error({
        message: 'Network Error',
        description: <><b>URL: </b>{url}<br /><b>STATUS TEXT: </b>{res.statusText}<br /><b>STATUS: </b>{res.status}</>,
        duration: 10,
      });
      console.log(`url:`, url);
      console.log(`request data:`, data);
      console.log(`response:`, res);
      return undefined;
    } catch (error) {
      this.notifyRequestError(error, {
        message: 'Network Error',
        description: <><b>URL: </b>{url}<br /></>,
        duration: 10,
      });
      console.log(`url:`, url);
      console.log(`request data:`, data);
      return undefined;
    }
  };
  protected tryPostLocalHost = async (
    url: string,
    data?: Record<any, any> | string,
    contentType: string = "application/json",
    noContentIsOk: boolean = false
  ): Promise<any> => {
    const config = {
      method: "post",
      url: url,
      baseURL: this.BASE_URL,
      headers: this.getHeaders(contentType),
      ...(data !== undefined && { data: data }),
    };
    try {
      const res = await axios(config);
      if (res.status==200) {
        return res;
      }
      this._configApi.notification.error({
        message: 'Network Error',
        description: <><b>URL: </b>{url}<br /><b>STATUS TEXT: </b>{res.statusText}<br /><b>STATUS: </b>{res.status}</>,
        duration: 10,
      });
      return undefined;
    } catch (error) {
      const errorResponse = (error as any)?.response;
      const responseMessage =
        typeof errorResponse?.data === "string"
          ? errorResponse.data
          : errorResponse?.data?.message || errorResponse?.data?.Message;

      this.notifyRequestError(error, {
        message: errorResponse?.status ? 'API Error' : 'Network Error',
        description: responseMessage ? (
          <>{responseMessage}</>
        ) : (
          <><b>URL: </b>{url}<br /></>
        ),
        duration: 10,
      });
      return undefined;
    }
  };
  protected tryPostHub = async (
    url: string,
    data?: Record<any, any> | string,
    contentType: string = "application/json",
    noContentIsOk: boolean = false
  ): Promise<any> => { 
    const config = {
      method: "post",
      url: url,
      baseURL: this.HUB_BASE_URL,
      headers: this.getHeaders(contentType),
      ...(data !== undefined && { data: JSON.stringify(data) }), // Ensuring the data is stringified if it's an object
    };
  
    try {
      const res = await axios(config);
      if (res.status==200) {
        return res;
      }
      this._configApi.notification.error({
        message: 'Network Error',
        description: <><b>URL: </b>{url}<br /><b>STATUS TEXT: </b>{res.statusText}<br /><b>STATUS: </b>{res.status}</>,
        duration: 10,
      });
      return undefined;
    } catch (error) {
      this.notifyRequestError(error, {
        message: 'Network Error',
        description: <><b>URL: </b>{url}<br /></>,
        duration: 10,
      });
      return undefined;
    }
  };

  protected tryGetHub = async (url: string): Promise<any> => {
    try {
      const res = await axios({
        method: "get",
        baseURL: this.HUB_BASE_URL,
        url: url,
        headers: this.getHeaders(),
      });
      if (res.status === 200) {
        return res;
      }
      return undefined;
    } catch (error) {
      console.log(`Hub GET error url:`, url, error);
      return undefined;
    }
  };
  
  protected tryTenantGet = async (
    url: string,
    data?: Record<any, any> | string,
    noContentIsOk: boolean = false
  ): Promise<any> => {
    const config = {
      method: "get",
      url: url,
      baseURL: this.BASE_URL,
      headers: this.getHeaders("multipart/form-data"),
      ...(data !== undefined && { data: data }),
    };
    try {
      const res = await axios(config);
      return res;
    } catch (error) {
      if (isApiUnavailableError(error) || isSessionExpiredError(error)) {
        return false;
      }

      Swal.fire({
        title: "Failure",
        text: "Something went wrong. Please try again or contact us",
        icon: "error",
        confirmButtonColor: "#44637e",
      });
      return false;
    }
  };
  

    private checkEmail = (str: string): string => {
        const validEmails: string[] = [
        "ven.pasynsoftdev4@associatedasset.com",
        "ven.pasynsoftdev2@associatedasset.com",
        "tmctesterson@aamaz.com",
        ];

        return validEmails.includes(str) ? "tnpatterson@associatedasset.com" : str;
    };


  private getRicHeader = (): Record<string, string> => {
    let randomizing = this.randomString();
    let KEY = this.formatString(this.xApiKey?.replace(/[-:;,._\\@/*&^%$#!()=+]/g, ""), 32, "0");
    let IV = this.formatString(
    `${randomizing}WWRQYHBC2iwkjqq366wfgWQ2qqiWEqD123SDfaAgxk5q1EfBshryYLo${randomizing}edKxjDqw4qqxWKFRf6E${randomizing}ZUC5qweq234JU6ozwUVLao`.replace(
        /[-:;,._\\@/*&^%$#!()=+]/g,
        ""
    ),
    16,
    "0"
    );

    let key = CryptoJS.enc.Utf8.parse(KEY);
    let iv = CryptoJS.enc.Utf8.parse(IV);

    let encrypted;

    let srcs = CryptoJS.enc.Utf8.parse(this.xApiKey);
    encrypted = CryptoJS.AES.encrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
    });

    let encryptedE;

    let srcsE = CryptoJS.enc.Utf8.parse(this.checkEmail(this._configApi.userEmail));

    encryptedE = CryptoJS.AES.encrypt(srcsE, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
    });

    return {
    "public-key": encrypted.ciphertext.toString(),
    "www": IV,
    "Email": encryptedE.ciphertext.toString(),
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "PUT, POST, GET, DELETE, PATCH, OPTIONS",
    "Access-Control-Allow-Headers": "Content-Type",
    "Access-Control-Max-Age": "1800",
    "Access-Control-Allow-Credentials": "true",
    };
};

  protected RicGet = async(url:string): Promise<any> =>{
    return await axios({
        method: 'get',
        baseURL: this.BASE_URLRIC,
        url: url,
        headers: this.getRicHeader(),
    });
}



}



export default MobileWebApiClient;
